import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceControl: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceControl"><Path d="M12.75 20H11.25V4H12.75V20Z" fill="currentColor"/><Path d="M8.75 17H7.25V7H8.75V17Z" fill="currentColor"/><Path d="M16.75 17H15.25V7H16.75V17Z" fill="currentColor"/><Path d="M4.75 15L1 12L4.75 9V15Z" fill="currentColor"/><Path d="M23 12L19.25 15V9L23 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceControl;
